<script lang="ts"></script>

<h2 class="text-headline-line">
    Lucky you!
</h2>

<p>
    A spot reserved for you freed up. You may now register!
</p>